import styled from 'styled-components'
import { Accordion as AccordionComponent } from 'components/molecules'
import {
  Content as AccordionContent,
  ToggleTrigger as AccordionToggleTrigger,
} from 'components/molecules/Accordion/Accordion.styles'

export const FilterOverlayContent = styled.div`
  .selected-filter {
    font-size: 14px;
    color: ${ (props) => props.theme.colors.grau2 };
  }

  .accordion-title {
    display: flex;

    & > span {
      margin-right: 8px;
    }
  }

  .indicator-description {
    display: flex;

    & > div:last-child {
      margin-left: 40px;
    }

    @media ${ (props) => props.theme.breakpoints.devices.max.xs } {
      flex-direction: column;

      & > div:last-child {
        margin-left: 0;
      }
    }
  }

  .indicator-row {
    display: flex;

    margin-bottom: 24px;

    .indicator-enumeration {
      margin-right: 8px;
    }

    .indicator {
      display: flex;
      flex-grow: 1;

      & > p {
        flex-grow: 1;
      }

      & > div:last-child {
        margin-left: 40px;
      }

      @media ${ (props) => props.theme.breakpoints.devices.max.xs } {
        flex-direction: column;

        & > div:last-child {
          margin-left: 0;
        }
      }
    }
  }
`

export const Accordion = styled(AccordionComponent)`
  background-color: transparent;

  ${ AccordionContent } {
    padding: 10px 15px;
  }

  ${ AccordionToggleTrigger } {
    padding: 10px 15px;
  }
`
